import contactApi from "../../../api/contact/contact";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  // 获取列表
  getList({ state }, { callback }) {
    console.log(state);
    contactApi.getListApi({ callback }, res => {
      callback(res);
    });
  },
  contact({ state }, { params, callback }) {
    console.log(state);
    contactApi.contactAgentApi({ params, callback }, res => {
      callback(res);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/contact/contact.js